import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, IconButton, Stack, Typography, useMediaQuery, } from "@mui/material";
import { FieldsForm, PopoutCard, } from "@pangeacyber/react-mui-shared";
import { getShareSettingsFields } from "./fields";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import { pickBy } from "lodash";
import { useStoreFileViewerContext } from "../../../hooks/context";
var ShareSettingsFieldsKeys = new Set(Object.keys(getShareSettingsFields()));
var ShareSettings = function (_a) {
    var object = _a.object, onSubmit = _a.onSubmit, onError = _a.onError, open = _a.open, setOpen = _a.setOpen;
    var theme = useTheme();
    var configurations = useStoreFileViewerContext().configurations;
    var isMedium = useMediaQuery(theme.breakpoints.down("md"));
    var buttonRef = useRef(null);
    var _b = useState(object), obj = _b[0], setObj = _b[1];
    var fields = useMemo(function () {
        var _a, _b;
        return getShareSettingsFields({
            maxAccessCount: (_a = configurations === null || configurations === void 0 ? void 0 : configurations.settings) === null || _a === void 0 ? void 0 : _a.maxAccessCount,
            maxDate: (_b = configurations === null || configurations === void 0 ? void 0 : configurations.settings) === null || _b === void 0 ? void 0 : _b.maxDate,
        });
    }, []);
    var handleClose = function () {
        setOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { ref: buttonRef, sx: { marginLeft: "auto" }, onClick: function () { return setOpen(!open); }, size: "small", "data-testid": "Share-Settings-Btn", children: _jsx(SettingsIcon, { fontSize: "small" }) }), isMedium ? (_jsx(PopoutCard, { anchorRef: buttonRef, open: open, setOpen: setOpen, placement: "bottom-end", PopperProps: {
                    style: {
                        zIndex: theme.zIndex.modal + 2,
                    },
                }, children: _jsxs(_Fragment, { children: [_jsxs(Stack, { direction: "row", paddingBottom: 1, alignItems: "center", justifyContent: "space-between", children: [_jsx(Typography, { color: "textContrast", children: "Settings" }), _jsx(IconButton, { sx: { marginLeft: "auto" }, onClick: handleClose, size: "small", "data-testid": "Settings-Close-Btn", children: _jsx(CloseIcon, { fontSize: "small", color: "inherit" }) })] }), _jsx(FieldsForm, { object: obj, fields: fields, autoSave: true, onError: onError, onSubmit: function (values) {
                                return onSubmit(
                                // @ts-ignore
                                pickBy(values, function (v, k) { return ShareSettingsFieldsKeys.has(k); }));
                            }, StackSx: {
                                ".MuiFormControl-root": {
                                    margin: 0,
                                },
                            } })] }) })) : (open && (_jsxs(Box, { className: "Pangea-Flyout-Container", sx: {
                    width: "220px",
                    height: "468px",
                    bgcolor: "#23315A",
                    color: theme.palette.primary.contrastText,
                    position: "absolute",
                    padding: 1,
                    top: "24px",
                    right: "-220px",
                    borderRadius: "0px 12px 12px 0px",
                    ".MuiTypography-root, .MuiStack-root > .MuiIconButton-root > .MuiSvgIcon-root": {
                        color: theme.palette.primary.contrastText,
                    },
                }, children: [_jsxs(Stack, { direction: "row", paddingBottom: 1, alignItems: "center", justifyContent: "space-between", children: [_jsx(Typography, { color: "textContrast", children: "Settings" }), _jsx(IconButton, { sx: { marginLeft: "auto" }, onClick: handleClose, size: "small", "data-testid": "Settings-Close-Btn", children: _jsx(CloseIcon, { fontSize: "small", color: "inherit" }) })] }), _jsx(FieldsForm, { object: obj, fields: fields, autoSave: true, onSubmit: function (values) {
                            return onSubmit(
                            // @ts-ignore
                            pickBy(values, function (v, k) { return ShareSettingsFieldsKeys.has(k); }));
                        }, onError: onError, StackSx: {
                            ".MuiFormControl-root": {
                                margin: 0,
                            },
                        } })] })))] }));
};
export default ShareSettings;
